var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-container',{staticClass:"message-board-page"},[_c('search-header',{attrs:{"total":_vm.total}}),_c('message-board-comment',{on:{"get-success":_vm.handleGetSuccess}}),(_vm.total===0)?_c('message-board-skeleton'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }